import { useNavigate, Link } from "react-router-dom";
import Button from "../components/Button";
import { useTheme } from "../hooks/useTheme";

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section>
      <h2 className="text-h2 text-text-main mb-2">{title}</h2>
      <div className="text-body text-text-secondary leading-relaxed space-y-2">{children}</div>
    </section>
  );
}

export default function Terms() {
  const navigate = useNavigate();
  const { theme } = useTheme();

  return (
    <div data-theme={theme} className="min-h-screen bg-surface-base py-8 px-4">
      <div className="max-w-3xl mx-auto space-y-5">
        <div className="flex items-center justify-between">
          <Button variant="secondary" size="sm" onClick={() => navigate(-1)}>
            بازگشت
          </Button>
          <span className="text-small text-text-tertiary">آخرین به‌روزرسانی: مرداد ۱۴۰۵</span>
        </div>

        <div className="card p-6 md:p-8">
          <h1 className="text-h1 text-text-main mb-1">قوانین و شرایط استفاده</h1>
          <p className="text-small text-text-tertiary mb-6">
            با استفاده از خدمات «درگاه هوش مصنوعی»، شما قوانین زیر را می‌پذیرید.
          </p>

          <div className="space-y-6">
            <Section title="۱. پذیرش شرایط">
              <p>
                با ثبت‌نام و استفاده از این سرویس، شما با قوانین و شرایط این صفحه موافقت می‌کنید. در
                صورت عدم موافقت با هر یک از این قوانین، از استفاده از سرویس خودداری کنید.
              </p>
            </Section>

            <Section title="۲. شارژ کیف پول و پرداخت">
              <p>
                تمامی پرداخت‌ها از طریق درگاه امن زرین‌پال انجام می‌شود. به مبلغ قابل پرداخت،
                مالیات ارزش افزوده (۱۰٪) اضافه می‌گردد که در فاکتور پرداخت به‌وضوح نمایش داده
                می‌شود. موجودی کیف پول شما تنها به‌اندازه مبلغ اصلی (بدون احتساب مالیات) شارژ
                می‌شود.
              </p>
              <p>
                حداقل مبلغ مجاز شارژ ۵۰٬۰۰۰ تومان است. هر تراکنش دارای کد رهگیری و کد وضعیت
                اختصاصی است که پس از پرداخت قابل مشاهده است.
              </p>
            </Section>

            <Section title="۳. استفاده از خدمات API">
              <p>
                مصرف منابع از موجودی کیف پول شما کسر می‌شود. هزینه هر درخواست بر اساس مدل انتخابی
                و میزان توکن مصرفی محاسبه و در بخش گزارش‌ها قابل پیگیری است.
              </p>
              <p>
                استفاده از خدمات برای هر فعالیت غیرقانونی، سوءاستفاده، یا نقض حقوق اشخاص ثالث
                ممنوع است و منجر به لغو حساب و ابطال موجودی می‌شود.
              </p>
            </Section>

            <Section title="۴. بازگشت وجه">
              <p>
                در صورت بروز خطا در پرداخت (به‌جز لغو توسط کاربر)، مبلغ پرداخت‌شده پس از بررسی
                به کیف پول شما بازگردانده می‌شود. درخواست‌های بازگشت وجه از طریق بخش پشتیبانی
                پیگیری می‌شود.
              </p>
            </Section>

            <Section title="۵. امنیت اطلاعات">
              <p>
                ما متعهد به حفاظت از اطلاعات شما هستیم. اطلاعات پرداخت و کلیدهای API شما به‌صورت
                امن نگهداری می‌شوند و تحت هیچ شرایطی در اختیار اشخاص ثالث قرار نمی‌گیرند.
              </p>
            </Section>

            <Section title="۶. تغییرات در شرایط">
              <p>
                ممکن است این شرایط در آینده به‌روزرسانی شود. ادامه استفاده از سرویس پس از اعمال
                تغییرات به‌منزله پذیرش شرایط جدید است.
              </p>
            </Section>
          </div>

          <div className="mt-8 pt-6 border-t border-line">
            <p className="text-small text-text-tertiary">
              سؤالی دارید؟ از طریق صفحه <Link to="/support" className="text-primary hover:underline">پشتیبانی</Link> با ما در ارتباط باشید.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
